<template>
<div class="GateWayFail">
    <div>
        <div class="column items-center">
             <div class="col" >
                <q-btn size="35px" round  color="teal" icon="far fa-check-circle"   />
            </div> 
            <div class="col text-h4 text-weight-medium header" >
                Request Submitted Successfully
            </div>
            <!-- <div class="col text-h4 text-weight-medium header" >
                {{TC_Reason}}
            </div> -->
        </div>
    </div>
</div>
</template>
<script>

import { QForm, QCard, QCardSection, QLinearProgress, Notify , QToggle, QInput, QSelect, QDialog, Loading} from 'quasar'
import axios from 'axios'

export default {
    name : 'GateWaySuccess',
    components : {
    },
    data() {
        return {
            
        }
    },
    props: {
        TC_TransactionStatus:String,
        TC_Reason:String,
    }, 
    mounted(){

    },
    computed: {
    },
    methods: {
          

    }
}
</script>

<style>
.header{
    color: #59599e;
}

</style>